var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgKycIcon = function SvgKycIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.75 7.9V5.83c0-1.71 1.38-3.08 3.08-3.08h2.16M21.1 7.9V5.83c0-1.71-1.38-3.08-3.08-3.08h-2.16M2.75 16.02v2.07c0 1.71 1.38 3.08 3.08 3.08h2.16M21.1 16.02v2.07c0 1.71-1.38 3.08-3.08 3.08h-2.16M11.8 10.7a2.47 2.47 0 1 0 0-4.94 2.47 2.47 0 0 0 0 4.94M6.82 17.53v-1.41a2.96 2.96 0 0 1 2.96-2.96h4.43a2.96 2.96 0 0 1 2.96 2.96v1.41"
  }))));
};
export default SvgKycIcon;